import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { ResetStateDefaults } from '../../../base-action-class.model';
import { RCheckinTemplate } from './r-checkin-template.action';

interface RCheckinTemplateXsStateModel {
  createCheckinTemplate: string | null;
  editCheckinTemplate: string | null;
  deleteCheckinTemplate: string | null;
}

const getDefaults = (): RCheckinTemplateXsStateModel => ({
  createCheckinTemplate: null,
  editCheckinTemplate: null,
  deleteCheckinTemplate: null,
});

@State<RCheckinTemplateXsStateModel>({
  name: 'rCheckinTemplate',
  defaults: getDefaults()
})
@Injectable()
export class RCheckinTemplateXsState {

  //region SELECTOR
  @Selector()
  static canCreateCheckinTemplate(state: RCheckinTemplateXsStateModel): boolean {
    return state.createCheckinTemplate != null;
  }

  @Selector()
  static canEditCheckinTemplate(state: RCheckinTemplateXsStateModel): boolean {
    return state.editCheckinTemplate != null;
  }

  @Selector()
  static canDeleteCheckinTemplate(state: RCheckinTemplateXsStateModel): boolean {
    return state.deleteCheckinTemplate != null;
  }
  //endregion

  //region ACTIONS
  @Action(RCheckinTemplate.SetCheckinTemplatePrivileges)
  public setCheckinTemplatePrivileges(
    ctx: StateContext<RCheckinTemplateXsStateModel>,
    action: RCheckinTemplate.SetCheckinTemplatePrivileges
  ): void {
    const state = ctx.getState();
    const checkinTemplatePrivileges: string[] = action.activeUserRightInfoDtoModel.checkinTemplatePrivileges
      ? [...action.activeUserRightInfoDtoModel.checkinTemplatePrivileges]
      : [];

    const createCheckinTemplate: string | null =
      checkinTemplatePrivileges.find(id => id === UserPrivilegeEnum.CREATE_CHECKIN_TEMPLATE) || null;
    const editCheckinTemplate: string | null =
      checkinTemplatePrivileges.find(id => id === UserPrivilegeEnum.EDIT_CHECKIN_TEMPLATE) || null;
    const deleteCheckinTemplate: string | null =
      checkinTemplatePrivileges.find(id => id === UserPrivilegeEnum.DELETE_CHECKIN_TEMPLATE) || null;

    ctx.setState({
      ...state,
      createCheckinTemplate,
      editCheckinTemplate,
      deleteCheckinTemplate
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RCheckinTemplateXsStateModel>): void {
    ctx.setState({ ...getDefaults() });
  }
  //endregion
}
